// extracted by mini-css-extract-plugin
export default {"GPUDisable":"Sticky_GPUDisable__HrgAf","fixMinHeight":"Sticky_fixMinHeight__S+yiA","placeHolderShimmer":"Sticky_placeHolderShimmer__oWBls"};